module.exports = __webpack_public_path__ + "static/media/mist.b2e40350.svg";